"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingCloudUserFactory = void 0;
const Utils_1 = require("../Utils");
const UserModel_1 = require("../UserModel");
class MarketingCloudUserFactory {
    static fromApiGatewayEvent(event) {
        return new UserModel_1.MarketingCloudUser({
            cognitoId: (0, Utils_1.getUserId)(event),
            principalId: (0, Utils_1.getUserId)(event),
            roles: (0, Utils_1.getRoles)(event),
            policies: (0, Utils_1.getPolicies)(event),
            holdingIds: (0, Utils_1.getHoldingIds)(event),
            businessEntityIds: (0, Utils_1.getBusinessEntityIds)(event),
            internalRole: (0, Utils_1.getInternalRole)(event),
            allowedApplications: (0, Utils_1.getAllowedApplications)(event),
        });
    }
    static fromSerialized(serialized) {
        const args = JSON.parse(serialized);
        return new UserModel_1.MarketingCloudUser(args);
    }
}
exports.MarketingCloudUserFactory = MarketingCloudUserFactory;
//# sourceMappingURL=MarketingCloudUserFactory.js.map